import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=01828743&scoped=true"
import script from "./couponDetail.vue?vue&type=script&lang=js"
export * from "./couponDetail.vue?vue&type=script&lang=js"
import style0 from "./couponDetail.vue?vue&type=style&index=0&id=01828743&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01828743",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01828743')) {
      api.createRecord('01828743', component.options)
    } else {
      api.reload('01828743', component.options)
    }
    module.hot.accept("./couponDetail.vue?vue&type=template&id=01828743&scoped=true", function () {
      api.rerender('01828743', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketingManage/couponManage/couponDetail.vue"
export default component.exports